import React, { useEffect, useState } from 'react';
import Header from '../../Components/JS/Headers.js';
import '../Styles/WhatWeDo.css';
import discord from '../../Assets/icons/discord.svg';
import uwo from '../../Assets/uwo.jpg';

const WhatWeDo = () => {
  const [isScreenLarge, setScreenLarge] = useState(window.innerWidth > 900);

  useEffect(() => {
    const handleResize = () => {
      setScreenLarge(window.innerWidth > 900);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Render differently for different screen sizes
  if (isScreenLarge) {
    return (
      <div className="what-we-do">
        <img className="about-photo" src={uwo} alt="UWO" />
        <div className="about-container">
          <Header name="about-csus-header" subheading="WHAT WE DO" heading="Meet students with your interests" />
          <p className="about-description">The Computer Science Undergraduate Society is the organization that represents computer science students at Western.</p>
          <a href="https://discord.gg/mgPQ97JHJb">
            <button className="join-discord-btn">
              <img src={discord} className="btn-discord-logo" alt="Discord Logo" />
              JOIN DISCORD SERVER
            </button>
          </a>
        </div>
      </div>
    );
  } else {
    return (
      <div className="what-we-do">
        <Header name="about-csus-header" subheading="WHAT WE DO" heading="Meet students with your interests" />
        <div className="about-container">
            <img className="about-photo" src={uwo} alt="UWO" />
          <p className="about-description">The Computer Science Undergraduate Society is the organization that represents computer science students at Western.</p>
          <a href="https://discord.gg/mgPQ97JHJb">
            <button className="join-discord-btn">
              <img src={discord} className="btn-discord-logo" alt="Discord Logo" />
              JOIN DISCORD SERVER
            </button>
          </a>
        </div>
      </div>
    );
  }
};

export default WhatWeDo;